import {
    FETCH_USERINFO_FAILURE,
    FETCH_USERINFO_SUCCESS,
    FETCH_ORDER_FAILURE,
    FETCH_ORDER_SUCCESS,
    FETCH_ORDER_REQUEST,
    FETCH_USER_REQUEST,
    FETCH_CURRENTBALANCE_REQUEST,
    FETCH_CURRENTBALANCE_SUCCESS,
    FETCH_CURRENTBALANCE_FAILURE,
    FETCH_CONFIRM_REQUEST,
    FETCH_CANCEL_FAILURE,
    FETCH_CANCEL_REQUEST,
    FETCH_CANCEL_SUCCESS
} from "./actionTypes"
import {
    FetchOrderSuccess,
    FetchOrderFailure,
    FetchUserSuccess,
    FetchUserFailure,
    FetchOrderFailurePayload,
    FetchOrderSuccessPayload,
    FetchUserFailurePayload,
    FetchUserSuccessPayload,
    FetchOrderRequest,
    FetchUserRequest,
    FetchBalanceRequest,
    FetchBalanceSuccessPayload,
    FetchBalanceSuccess,
    FetchBalanceFailure,
    FetchConfirmRequest,
    FetchCancelFailure,
    FetchCancelRequest,
    FetchCancelSuccess,
    FetchCancelFailurePayload
} from "./types"
export const fetchCancelRequest = (obj: any): FetchCancelRequest =>({
    type: FETCH_CANCEL_REQUEST,
    body: obj.body
})
export const fetchConfirmRequest = (obj:any): FetchConfirmRequest =>({
    type: FETCH_CONFIRM_REQUEST,
    params: obj.params,
    id: obj.id,
    status: obj.status
})
export const fetchUserRequest = (obj: any): FetchUserRequest =>({
    type: FETCH_USER_REQUEST,
    params: obj.params,
    userId: obj.userId
})
export const fetchOrderRequest = (obj: any): FetchOrderRequest =>({
    type: FETCH_ORDER_REQUEST,
    params: obj.params,
    userId: obj.userId
})
export const fetchBalanceRequest = (obj: any): FetchBalanceRequest =>({
    type: FETCH_CURRENTBALANCE_REQUEST,
    params: obj.params
})
export const fetchCancelSuccess = (): FetchCancelSuccess=>({
    type: FETCH_CANCEL_SUCCESS
})
export const fetchUserSuccess = (
    payload: FetchUserSuccessPayload
): FetchUserSuccess => ({
    type: FETCH_USERINFO_SUCCESS,
    payload,
})
export const fetchUserFailure = (
    payload: FetchUserFailurePayload
): FetchUserFailure => ({
    type: FETCH_USERINFO_FAILURE,
    payload,
})
export const fetchOrderSuccess = (
    payload: FetchOrderSuccessPayload
): FetchOrderSuccess =>({
    type: FETCH_ORDER_SUCCESS,
    payload
})
export const fetchOrderFailure = (
    payload: FetchOrderFailurePayload
): FetchOrderFailure =>({
    type: FETCH_ORDER_FAILURE,
    payload
})
export const fetchBalanceSuccess = (
    payload: FetchBalanceSuccessPayload
): FetchBalanceSuccess =>({
    type: FETCH_CURRENTBALANCE_SUCCESS,
    payload
})
export const fetchBalanceFailure = (
    payload: FetchOrderFailurePayload
): FetchBalanceFailure =>({
    type: FETCH_CURRENTBALANCE_FAILURE,
    payload
})
export const fetchCancelFailure =(
    payload: FetchCancelFailurePayload
): FetchCancelFailure =>({
    type: FETCH_CANCEL_FAILURE,
    payload
})